const Days = [
  { id: '7', name: 'Sunday' },
  { id: '1', name: 'Monday' },
  { id: '2', name: 'Tuesday' },
  { id: '3', name: 'Wednesday' },
  { id: '4', name: 'Thursday' },
  { id: '5', name: 'Friday' },
  { id: '6', name: 'Saturday' }
];

export default Days;



// WEBPACK FOOTER //
// ./src/views/StaticData/Days.tsx